import { useState } from 'react';
import { Avatar, Button, Card, Checkbox, Field, Input, Logo, Radio, Select, Switch, Tabs, Textarea } from '../../design';
import { useAuth } from '../../auth/AuthProvider';

export function SettingsScreen() {
  const { user } = useAuth();
  const [tab, setTab] = useState('Profile');

  return (
    <>
      <Tabs items={['Profile', 'Delivery', 'Billing', 'Notifications']} value={tab} onChange={setTab} />

      <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 'var(--space-6)', alignItems: 'start' }}>
        <Card title="Practitioner profile" pad="lg">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-6)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-5)' }}>
              <Avatar name={user?.name || 'Zen Mindware'} size="xl" />
              <div style={{ display: 'flex', gap: 'var(--space-4)' }}>
                <Button size="sm" variant="secondary" icon="upload">
                  Replace photo
                </Button>
                <Button size="sm" variant="ghost">
                  Remove
                </Button>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-5)' }}>
              <Field label="Display name">
                <Input defaultValue={user?.name || ''} />
              </Field>
              <Field label="Title">
                <Input defaultValue="Hypnotist & relationship coach" />
              </Field>
            </div>
            <Field label="Public bio" hint="Shown on your booking page.">
              <Textarea rows={4} defaultValue="Liev Black is a hypnotist and life and relationship coach with 20 years of experience." />
            </Field>
            <Field label="Time zone">
              <Select options={['Europe/Copenhagen', 'America/New_York', 'UTC']} />
            </Field>
            <div style={{ display: 'flex', gap: 'var(--space-4)' }}>
              <Button size="sm">Save changes</Button>
              <Button size="sm" variant="ghost">
                Discard
              </Button>
            </div>
          </div>
        </Card>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-6)' }}>
          <Card title="Default program delivery" pad="lg">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
              <Radio name="delivery" label="Ultrasonic (seemingly silent)" defaultChecked />
              <Radio name="delivery" label="Audible affirmations" />
              <Radio name="delivery" label="Binaural tones" />
              <Radio name="delivery" label="Visual subliminal" disabled />
            </div>
          </Card>
          <Card title="Notifications" pad="lg">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)' }}>
              <Switch label="Email me when a session is booked" defaultChecked />
              <Switch label="Weekly practice summary" defaultChecked />
              <Switch label="Client listening milestones" />
              <Checkbox label="Include client names in email subjects" />
            </div>
          </Card>
          <Card variant="soft" pad="lg">
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-5)' }}>
              <Logo variant="mark" height={40} />
              <div style={{ font: 'var(--type-caption)', color: 'var(--text-muted)' }}>
                Practitioners' Portal · build 2026.08 · <a href="#">Legal notices</a>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
